export default __webpack_public_path__ + "static/media/LightCloud.edc43777.png";